
/*
 * GABADINI SLEEP — CENTRAL CAMPAIGN DEFINITIONS
 * Stage 1: Campaign data model
 *
 * This file contains campaign configuration only.
 * It does not apply discounts or change the cart.
 */

window.GabadiniCampaigns = {
    FIRE50: {
    id: "FIRE50",
    landingPath: "/pages/sleep50",

    audience: "Fire Services",

    offer: {
      id: "FIRST_SUBSCRIPTION_50",
      type: "first_subscription_payment",
      headline: "50% off your first subscription order",
      renewalMessage:
        "Normal subscription pricing applies to future orders."
    },

    discounts: {
      single: {
        code: "SLEEP50SINGLE",
        percentage: 45
      },

      bundle: {
        code: "SLEEP50",
        percentage: 34
      }
    },

    attribution: {
      campaign: "FIRE50",
      audience: "Fire Services",
      source: "email"
    }
  }
};
